import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.js';

import { useNotificationStore } from '@/stores/notification.js';
import { useUserStore } from '@/stores/user';
import app from '@/main.js';

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        // if the route is the same, don't scroll
        if (to.name === from.name) {
            return false;
        }

        const rightPanel = document.getElementById('app-right-panel');
        if (rightPanel) {
            try {
                rightPanel.scrollTo({
                    top: 0,
                    behavior: 'instant', // Modern browsers
                });
            } catch (e) {
                // Fallback for browsers that don't support 'instant'
                rightPanel.scrollTop = 0;
            }
        }
    },
    routes,
});

/* Removed
router.beforeEach((to, from, next) => {

    const isAuthenticated = ('token' in localStorage)
    const routeRequiresAuthentication = !('requiresAuth' in to.meta) || to.meta.requiresAuth

    // require auth unless otherwise specified in meta.requiresAuth
    if (!routeRequiresAuthentication || isAuthenticated)
        next()
    else
        next({ name: 'Login' })
})
*/
// ... existing code ...

router.beforeEach(async (to) => {
    const userStore = useUserStore();

    // Allow access to public routes immediately
    if (to.meta.requiresAuth === false) {
        return true;
    }

    // For protected routes, check authentication
    try {
        // Always perform sync to ensure we have latest user data and wait for it to complete
        await new Promise((resolve, reject) => {
            userStore.sync(() => {
                resolve();
            });
        });

        // Check if user is authenticated after sync, if not redirect to login
        if (userStore.isAuthenticated && userStore.user) {
            return true;
        } else {
            // If the user is not authenticated, redirect to login with the current path as the redirect query
            return { name: 'Login', query: { redirect: to.fullPath }, replace: true };
        }
    } catch (error) {
        // On error, redirect to login with the current path as the redirect query
        return { name: 'Login', query: { redirect: to.fullPath }, replace: true };
    }
});

let lastFetchTime = 0; // Initialize to 0 so it runs on first route change

router.beforeEach((to, from, next) => {
    if (!app) return next();

    const notificationStore = useNotificationStore();
    if (!notificationStore) return next();

    const now = Date.now();

    if (now - lastFetchTime > 30000) {
        // 30 seconds = 30000 milliseconds
        notificationStore.sync();
        lastFetchTime = now;
    }

    next();
});

export default router;
